// Label metrics are in viewBox units of the 100-unit SVG, so they scale with the rendered diameter.
export const LABEL_MAX_FONT_SIZE = 50;
// The ring (radius 46, stroke 8) leaves an 84-unit clear circle; 70 keeps the label off the stroke
// even where the circle narrows at the text's vertical extent.
export const LABEL_MAX_WIDTH = 70;
// Approximate Source Sans Pro advance widths for the only characters a label can contain.
export const DIGIT_EM_WIDTH = 0.5;
export const SEPARATOR_EM_WIDTH = 0.28;
// Lining digits span baseline to cap height, so shifting the baseline down by half the cap height centers them
// visually (dominant-baseline would center on x-height, leaving digits high). Source Sans Pro, the application font,
// has a 0.66em cap height; the sans-serif fallbacks (~0.72em) stay within half a pixel.
export const LABEL_BASELINE_SHIFT = '0.33em';
